// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X8WOA764yXoFYj {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
@supports not (grid-template-columns: subgrid) {
  .X8WOA764yXoFYj {
    grid-template-columns: [icon] 40px [body] minmax(0, 1fr);
  }
}
@media print {
  .X8WOA764yXoFYj {
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin-bottom: 1em;
  }
}
.Vxo8_5HVQSGTlQ {
  margin-left: var(--ds-space-negative-150, -12px);
  padding-left: var(--ds-space-100, 8px);
  border-left: 4px solid var(--ds-border-information, #1d7afc);
  background: var(--ds-background-information, #e9f2ff);
}
.MNSgV5ahPwTeQM {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `X8WOA764yXoFYj`,
	"highlightedWrapper": `Vxo8_5HVQSGTlQ`,
	"boardAction": `MNSgV5ahPwTeQM`
};
export default ___CSS_LOADER_EXPORT___;
